export class AddActivityViewInput {

    topicId: Number;
    userId: Number;
    userAssociationTypeId: number;
    userCategoryId: number;
    percentageWatched: number;
}
